<template>
  <div>
	  <a-col :span="24" :xl="8">
	    <a-row :gutter="[8, 8]">
	  	<a-col>
	  	  <p>每日任务开始时间</p>
	  	</a-col>
	  	<a-col>
	  	  <a-input placeholder="请选择每日任务开始时间"  @click="showModal"></a-input>
	  	</a-col>
	    </a-row>
	  </a-col>
   
    <a-modal v-model="visible" title="任务开始时间" ok-text="确认" cancel-text="取消" @ok="handleOk">
      <p>每日任务开始时间</p>
	  <a-row>
		  <a-col>
			  <a-time-picker :default-open-value="moment('00:00:00', 'HH:mm:ss')" @change="onChange" />
			  <a-speace></a-speace>
			  <a-button>添加</a-button>
		  </a-col>
	  </a-row>
	  <p>选择时间</p>
    </a-modal>
	
	<a-modal v-model="visibleDay" title="任务生成日期" ok-text="确认" cancel-text="取消" @ok="handleOk">
		 <p>选择日期（日）</p>
		 <div>1</div>
	</a-modal>
	
	<a-modal v-model="visibleWeek" title="任务生成日期" ok-text="确认" cancel-text="取消" @ok="handleOk">
		 <p>选择日期（周）</p>
		 <div>周一</div>
	</a-modal>
	
	<a-modal v-model="visibleMoth" title="任务生成日期" ok-text="确认" cancel-text="取消" @ok="handleOk">
		 <p>选择日期（日）</p>
		 <!-- <div>1月</div> -->
		 <div>
			 <a-tabs default-active-key="1" @change="callback">
				   <a-tab-pane v-for="i in 12" :key="i" :tab="`${i}月`"> {{ i }}月 </a-tab-pane>
			 </a-tabs>
		 </div>
	</a-modal>
  </div>
</template>
<script>
	import moment from 'moment';
export default {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
	moment,
	onChange(time, timeString) {
		console.log(time, timeString);
	},  
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      // console.log(e);
      this.visible = false;
    },
	// 这个是月份的回调
	callback(key) {
		  console.log(key);
		},
  },
};
</script>
